import { Component, Input } from '@angular/core';
import { TimeDisplayMode } from '@services/timeDisplay/time-display.service';

@Component({
  selector: 'app-time-display-menu',
  template: `
    <ion-list class="time-display-menu">
      <ion-list-header>
        <ion-label>{{ 'WORK_SCHEDULE.Time_Display' | translate }}</ion-label>
      </ion-list-header>
      <ion-item
        *ngFor="let mode of modes"
        button
        [class.selected]="mode.value === currentMode"
        (click)="selectMode(mode.value)">
        <ion-icon
          [name]="mode.icon"
          slot="start"
          [color]="mode.value === currentMode ? 'primary' : 'medium'">
        </ion-icon>
        <ion-label>{{ mode.label | translate }}</ion-label>
        <ion-icon
          *ngIf="mode.value === currentMode"
          name="checkmark"
          slot="end"
          color="primary">
        </ion-icon>
      </ion-item>
    </ion-list>
  `,
  styles: [`
    .time-display-menu {
      padding: 0;
      min-width: 180px;

      ion-list-header {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        color: var(--ccs-color-form-prompt);
        min-height: 32px;
        padding-top: 8px;
      }

      ion-item {
        --padding-start: 12px;
        --padding-end: 12px;
        --min-height: 40px;
        font-size: 14px;
        cursor: pointer;

        &.selected {
          --background: var(--ccs-supporting-light-grey);
          font-weight: 500;
        }

        ion-icon[slot="start"] {
          margin-right: 12px;
          font-size: 18px;
        }

        ion-icon[slot="end"] {
          font-size: 16px;
        }
      }
    }
  `]
})
export class TimeDisplayMenuComponent {
  @Input() currentMode: TimeDisplayMode = TimeDisplayMode.Clock;
  @Input() onSelect: (mode: TimeDisplayMode) => void;

  public modes: { value: TimeDisplayMode; label: string; icon: string }[] = [
    { value: TimeDisplayMode.Clock, label: 'WORK_SCHEDULE.Clock_Time', icon: 'time-outline' },
    { value: TimeDisplayMode.Work, label: 'WORK_SCHEDULE.Work_Time', icon: 'briefcase-outline' },
    { value: TimeDisplayMode.Both, label: 'WORK_SCHEDULE.Show_Both', icon: 'layers-outline' }
  ];

  public selectMode(mode: TimeDisplayMode): void {
    if (this.onSelect) {
      this.onSelect(mode);
    }
  }
}
